"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
const noop = () => null;
exports.noop = noop;
